import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_URL && !process.env.REACT_APP_API_URL.includes('gsulespalmiers.bj/api'))
  ? process.env.REACT_APP_API_URL
  : 'https://gsu-palmiers-backend.onrender.com/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('⚠️ Requête non authentifiée (401) sur :', error.config?.url);
    }
    return Promise.reject(error);
  }
);

export default api;
